const e = "naive-ui-style";
export {
  e as cssrAnchorMetaName
};
